import get from 'lodash/get';
import assign from 'lodash/assign';
import ngFocusIf from 'ng-focus-if';

import { FullscreenLoaderService } from 'components/fullscreenLoader/fullscreenLoader.service';
import { AuthService } from 'services/auth.service';
import { ApiService } from 'services/api.service';
import { ModalService } from 'services/modal.service';
import { CheckoutService } from 'services/checkout.service';
import { ShopperAccountService } from 'services/shopperAccount.service';

import template from './loginForm.html';
import './loginForm.scss';

export const LoginForm = angular
    .module('checkout.components.loginForm', [
        ngFocusIf,
        FullscreenLoaderService,
        ApiService,
        ModalService,
        AuthService,
        CheckoutService,
        ShopperAccountService
    ]).component('loginForm', {
        template,
        bindings: {
            onForgotPasswordClicked: '&',
            showPasswordResetSuccessMessage: '<',
            initEmail: '<',
            message: '<'
        },
        controller: class LoginFormCtrl {
            constructor(
                $mdDialog,
                checkoutService,
                authService,
                shopperAccountService,
                loadingService
            ) {
                assign(this, {
                    $mdDialog,
                    checkoutService,
                    authService,
                    shopperAccountService,
                    loadingService,
                    showPassword: false,
                    model: {}
                });
            }

            $onInit() {
                if (this.initEmail) {
                    this.model.email = this.initEmail;
                }
            }

            onCloseButtonClicked() {
                this.$mdDialog.cancel();
            }

            onFormSubmit() {
                this.login();
            }

            login() {
                if (this.loginForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.loginForm);
                    return;
                }

                this.errorMessage = null;
                this.loadingService.show('Logging in...');

                return this.authService.login(this.model.email, this.model.password)
                    .then(() => this.$mdDialog.hide())
                    .catch((response) => {
                        const errorReason = get(response, 'data.error', 'unknown');

                        if (errorReason === 'invalid_user_password' || errorReason === 'invalid_grant') {
                            this.errorMessage = 'Invalid username or password';
                        } else if (errorReason === 'too_many_attempts') {
                            this.errorMessage = 'Too many login attempts';
                        } else {
                            this.errorMessage = 'Your email or password is incorrect. Please re-enter and try again.';
                        }

                        this.loadingService.hide();

                        return response;
                    });
            }

            onTogglePasswordVisibilityClick() {
                this.showPassword = !this.showPassword;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/loginModal/loginForm/loginForm.js